angular.module('CarsSaraBo').controller('AvailabilityController', [
	'$scope', '$routeParams', 'AvailabilityService', 'PointOfSaleService', 'ContractService',
	'$location', 'GAService','HotjarService', 'SessionService', 'NotificationService', 'ModalService',
	'LoadingWheelService', '$q', 'AlertEmailService',
	function ($scope, $routeParams, availabilityService, pointOfSaleService, contractService, $location, gaService,
			  hotjarService, sessionService, notificationService, modalService, loadingWheelService, $q, alertEmailService) {

		function initialize () {
			$scope.allCarsStockUsed = false;
			loadingWheelService.show();
			$scope.period = {from: new Date(), to: null};
			$scope.errorMessages = {};
			$scope.cars = {};
			$scope.contractOid = null;
			$scope.daysSelected = {
				"MONDAY": {"checked": true}, "TUESDAY": {"checked": true}, "WEDNESDAY": {"checked": true},
				"THURSDAY": {"checked": true}, "FRIDAY": {"checked": true}, "SATURDAY": {"checked": true}, "SUNDAY": {"checked": true}
			};
			$scope.days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
			$scope.selectedAll = {days: true};
			$scope.editableAvailability = sessionService.loggedUserAllowed('PERM_AVAILABILITY_EDIT');
			$scope.companyOid = $routeParams.oid;
			$scope.validations = {};
            $scope.alertsByPos = {};
            $scope.noAlertsInPos = [];
            $scope.emptyAlerts = [];
            $scope.updateDate = calculateMaxDate();
            notifyGA("page_views", ["Page view"]);
			loadAvailability();
			loadAlertsByCompany();
		}

		$scope.setValueForAllCars = function (stockForAll) {
			if (!stockForAll || stockForAll.trim() === '') {
				stockForAll = undefined;
			}
			angular.forEach($scope.fleet, function (car) {
				$scope.cars[car.oid] = stockForAll;
			});
			$scope.allCarsStockUsed = true;
		};

		function calculateMaxDate() {
			var date = new Date();
			let dateWithYears = new Date(date.setFullYear(new Date().getFullYear() + 2));
			return formatDate(dateWithYears);
		}

		function formatDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [d.getFullYear(), pad(d.getMonth()+1), pad(d.getDate())].join('-');
		}

		function loadAlertsByCompany(){
            alertEmailService.query({companyOid: $routeParams.oid}, function (response) {
                $scope.validations.totalEmails = [];
                _.each(response, function (elem) {
                    $scope.validations.totalEmails.push(elem.email);
                    _.each(elem.pointOfSaleOids, function (pos) {
                        if(!($scope.alertsByPos.hasOwnProperty(pos))){
                            $scope.alertsByPos[pos] = [];
                        }
                        for (var i in elem.types){
                            if ($scope.alertsByPos[pos].indexOf(elem.types[i]) == -1){
                                $scope.alertsByPos[pos].push(elem.types[i]);
                            }
                        }
                    });
                });
            });
		}

		function loadAvailability() {
			availabilityService.getResources($routeParams.oid).then(function (response) {
				carCallback(response[0]);
				alertsCallback(response[1]);
				posCallback(response[2]);
			});

			function carCallback(cars) {
				$scope.fleet = cars;
				$scope.validations.fleet = true;
			}

			function alertsCallback(alerts) {
				$scope.validations.hasRequiredAlerts = ["RESERVE_MODIFICATION", "CANCELLATION", "RESERVE"];
				_.each(alerts, function (elem) {
					_.each(elem.types, function (type) {
						var index = $scope.validations.hasRequiredAlerts.indexOf(type);
						if (index > -1) {
							$scope.validations.hasRequiredAlerts.splice(index, 1);
						}
					});
				});
			}

			function posCallback(pointsOfSale) {
				$scope.pointsOfSale = [];
				$scope.pointsOfSale = pointsOfSale;
				$scope.validations.pointsOfSale = true;
				var fieldsContract = "name,oid,period,pointsOfSale"
				contractService.getAll({companyOid: $routeParams.oid, fields: fieldsContract}, function (response) {
					$scope.contracts = [];
					$scope.validations.contracts = true;
					//Solo muestra los contratos que tiene alguna sucursal asociada.
					for (i = 0; i < response.length; i++) {
						contract = response[i];
						isOk = (_.filter($scope.pointsOfSale, function (pos) {
								return _.includes(contract.pointsOfSale, pos.oid);
							})).length > 0;
						if (isOk) {
							$scope.contracts[$scope.contracts.length] = contract;
						}
					}
					$scope.contractOid = $scope.contracts[0] ? $scope.contracts[0].oid : 0;
					if ($scope.contractOid) {
						updateStartDate();
					}
					$scope.pointsOfSaleSelector = pointOfSaleService.getPointsOfSaleSelectorConfig($scope.pointsOfSale);
					loadingWheelService.hide();
				});
			}
		}

		function updateStartDate() {
			$scope.period.from = getAvailableStartDate();
		}

		function getAvailableStartDate() {
			var contract = _.find($scope.contracts, {oid: $scope.contractOid});
			var from = toDate(contract.period.from);
			if (from > new Date()) {
				return from;
			} else {
				return new Date();
			}
		}

		$scope.verifyAllDays = function () {
			$scope.selectedAll.days = $scope.allSelected($scope.daysSelected);
		};

		$scope.updateValidation = function (field) {
			if ($scope.errorField != undefined && $scope.errorField[field]) {
				$scope.errorField[field] = null;
			}
		};

		$scope.save = function () {
			var deferred = $q.defer();
			$scope.errorField = {};
			$scope.submitted = true;
			if (isValid() && $scope.availabilityForm.$valid) {
				var days = _.map($scope.daysSelected, function (val, key) {
					if (val.checked == true) {
						return key;
					}
				});
				availabilityService.save($scope.companyOid, $scope.cars, $scope.period, $scope.pointsOfSaleSelector.getSelectedItemsOid(),
					days, $scope.contractOid)
					.then(function (response) {
						trackGA();
                        hotjarService.triggerStockSurvey($scope.cars);
                        deferred.resolve();
						initialize();
						notificationService.notifyInfoByCode('availability.confirmationMessage.SUCCESS_SAVE');
					}, function (error){
						deferred.reject();
					});
			} else {
				deferred.reject();
				notifyGA("submit_form", ["Error"]);
				for (i in $scope.availabilityForm.$error.required) {
					var name = $scope.availabilityForm.$error.required[i].$name;
					$scope.errorField[name] = "input-error";
					notifyGA("errores_validacion", [name + ":required"]);
				}
			}
			notificationService.notifyFormErrors($scope.availabilityForm.$error);
			return deferred.promise;
		};

		$scope.cancel = function () {
			modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function () {
				$location.path("/company/" + $routeParams.oid + "/availability/");
			});
		};

		/*****VALIDATIONS******/

		$scope.checkAllDays = function () {
			var select = $scope.selectedAll.days;
			angular.forEach($scope.days, function (item) {
				$scope.daysSelected[item] = {"checked": select};
			});
		};

		function isValid() {
			var isValid = true;
            var errorList = [];
            var errorMessageList = [];

			if (!_.some($scope.pointsOfSaleSelector.getSelectedItemsOid())) {
				isValid = false;
				$scope.errorField['pointsOfSale'] = "input-error";
			}

			if (!checkAvailability($scope.cars)) {
				isValid = false;
				$scope.errorField['carAvailability'] = "input-error";
				notifyGA("errores_validacion", ["carAvailability:invalid"]);
			}

			if(!checkValidAlerts()){
                isValid = false;
                $scope.errorField['pointsOfSale'] = "input-error";
                if($scope.noAlertsInPos.length > 0){
                    errorMessageList.push({
                        code: "alert.NO_ALERTS_REGISTERED_TITLE",
                        params: ["alertEmail.RESERVE", "alertEmail.CANCELLATION", "alertEmail.MODIFICATIONS", "alert.NO_VALID_MAIL_ACTION"]
                    });
                }
                if($scope.emptyAlerts.length > 0 && $scope.emptyAlerts.length <=2){
                    errorMessageList.push({
                        code: "alert.NO_VALID_MAIL_POS",
                        params: [$scope.emptyAlerts.join(', '), "alert.NO_VALID_MAIL_ACTION"]
                    });
				}else if( $scope.emptyAlerts.length > 2){
                    errorMessageList.push({
                        code: "alert.NO_VALID_MAIL_ALL",
                        params: ["alert.NO_VALID_MAIL_ACTION"]
                    });
				}

                for (var i in errorMessageList) {
                    notificationService.notifyErrorByCodeWithMessageAndErrorList(errorMessageList[i].code, errorMessageList[i].params);
                }
            }

			if ($scope.period.from && $scope.period.to && $scope.period.from.setHours(0, 0, 0, 0) > $scope.period.to.setHours(0, 0, 0, 0)) {
				isValid = false;
				$scope.errorField['maxDate'] = "input-error";
				notifyGA("errores_validacion", ["period:invalid"]);
			}

			var contract = _.find($scope.contracts, {oid: $scope.contractOid});
            var today = moment().startOf('day');
			var contractFrom = moment(contract.period.from).startOf('day');

            var validFrom = contractFrom > today ? contractFrom : today;
            var validTo = moment().add(2, 'y').startOf('day');

			if ($scope.period.to > validTo || $scope.period.from < validFrom) {
				isValid = false;
				$scope.errorField['rangeDate'] = "input-error";
				errorList.push({
					code: "common.INVALID_PERIOD",
					params: {
						contractFrom: validFrom.format("D/MM/YYYY"),
						contractTo: validTo.format("D/MM/YYYY")}
				});
				notifyGA("errores_validacion", ["period:ouf_of_contract"]);
			}

			if (errorList.length > 0) {
				for (var i in errorList) {
					notificationService.notifyErrorByCodeWithParams(errorList[i].code, errorList[i].params);
				}
			}

			return isValid;
		}

		function toDate(dateString) {
			return moment(dateString).toDate();
		}

        function getPosNames(selectedPos){
			$scope.emptyAlerts = [];
            _.each(selectedPos, function (posOid) {
            	_.each($scope.pointsOfSale, function (pos){
					if(posOid == pos.oid){
                        $scope.emptyAlerts.push(pos.name);
					}
				})
            });
        }

		function checkValidAlerts(){
            var isValid = true;
            var selectedPos = $scope.pointsOfSaleSelector.getSelectedItemsOid(); //sucursales seleccionadas
            var emptyAlerts = [];
            $scope.noAlertsInPos = [];

			for (var i in selectedPos){
                if($scope.alertsByPos.hasOwnProperty(selectedPos[i])){
                    _.forEach($scope.alertsByPos, function(alerts, pos) {
                        if(selectedPos[i] == pos){
                            if(alerts.indexOf('RESERVE') == -1 || alerts.indexOf('CANCELLATION') == -1
                                || alerts.indexOf('RESERVE_MODIFICATION') == -1){
                                $scope.noAlertsInPos.push(pos);
                                isValid = false;
                                return false;
                            }
                        }
                    });
                }else{
                	emptyAlerts.push(selectedPos[i]);
                	isValid = false;
				}
            }
            getPosNames(emptyAlerts);
            return isValid;
        }

		function checkAvailability(stocks, keyName) {
			var isCorrect = false;
			for (i in stocks) {
				if (stocks[i] != "" && stocks[i] != null) {
					if (stocks[i] >= 0) {
						isCorrect = true;
					} else if (stocks[i] < 0) {
						return false;
					}
				}
			}
			return isCorrect;
		}

		function notifyGA(eventName, paramsList) {
			gaService.notify("Autos_disponibilidad", eventName, paramsList);
		}

		function trackGA() {
			notifyGA("submit_form", ["Exitoso"]);
			if ($scope.allCarsStockUsed) {
				notifyGA("editar_stock", ["TODOS"]);
			} else {
				notifyGA("editar_stock", ["AUTOS"]);
			}
			if ($scope.selectedAll.pos) {
				notifyGA("seleccionar_sucursal", ["TODOS"]);
			} else {
				notifyGA("seleccionar_sucursal", ["SUCURSALES"]);
			}
			if ($scope.selectedAll.days) {
				notifyGA("seleccionar_dias", ["Todos"]);
			} else {
				var d = new Array();
				$.each($scope.daysSelected, function (key, value) {
					if (value.checked) {
						d.push(key);
					}
				});
				notifyGA("seleccionar_dias", d);
			}
		}

		initialize();
	}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/availability/availability_controller.js
// module id = 931
// module chunks = 3